import { type FriendCheckState } from "../hooks/useFriendcheck";
import { type MyData } from "../query/functions/user/data";
import { Routes } from "../router";

export class FriendCheckRouter {
	constructor(private readonly friendCheckService: FriendCheckService) {}

	dashboard(myData: MyData) {
		if (!myData.modal.friendCheckExplainer.seen) {
			return Routes.FriendCheckExplainer();
		}

		return Routes.FriendCheckDashboard();
	}
}

export class FriendCheckService {
	router: FriendCheckRouter;

	constructor(private readonly friendCheckState: FriendCheckState) {
		this.router = new FriendCheckRouter(this);
	}
}
